import { render, staticRenderFns } from "./claimInfoOld.vue?vue&type=template&id=8629857c&scoped=true"
import script from "./claimInfoOld.vue?vue&type=script&lang=js"
export * from "./claimInfoOld.vue?vue&type=script&lang=js"
import style0 from "./claimInfoOld.vue?vue&type=style&index=0&id=8629857c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8629857c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8629857c')) {
      api.createRecord('8629857c', component.options)
    } else {
      api.reload('8629857c', component.options)
    }
    module.hot.accept("./claimInfoOld.vue?vue&type=template&id=8629857c&scoped=true", function () {
      api.rerender('8629857c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordManage/claimInfoOld.vue"
export default component.exports